
/**
 * @file api-helper.ts
 * @module app/modules/_common/utils/api-helper
 * @description Provides utility functions for handling structured API responses.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.1
 * @version 2.1.2
 */

import { CONFIGURATION_SETTING_KEYS } from "src/utils/configurationSettingKeys";
import { ApiResponseToastStatus } from "src/utils/apiResponseToast";
import { notifyByKey } from "src/app/modules/_common/utils/sweet-alert";

export const getRecordFromStructuredResponse = (apiResponse: any) => {
  if (!apiResponse) {
    return null;
  }
  return Array.isArray(apiResponse.record)
    ? apiResponse.record[0]
    : apiResponse.record;
};

export const showSilentResponseNotification = (
  status: ApiResponseToastStatus,
  message: string,
) => {
  void notifyByKey(
    CONFIGURATION_SETTING_KEYS.KEY__NOTIFICATION_SWAL_BASIC_TYPE,
    [status, message],
    false,
  );
};